(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bambulaco-ecosystem-home"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('[data-ce-home]').forEach(root=>{const categories=[...root.querySelectorAll('[data-ce-category]')];const activateCategory=selected=>{categories.forEach(category=>{const active=category===selected;category.classList.toggle('active',active);if(active){category.setAttribute('aria-current','page')}else{category.removeAttribute('aria-current')}})};categories.forEach(category=>{category.addEventListener('pointerdown',()=>activateCategory(category));category.addEventListener('click',()=>activateCategory(category))});const slides=[...root.querySelectorAll('[data-ce-slide]')],dots=[...root.querySelectorAll('[data-ce-dot]')],prev=root.querySelector('[data-ce-prev]'),next=root.querySelector('[data-ce-next]');if(slides.length<2)return;let active=0,timer;const show=n=>{active=(n+slides.length)%slides.length;slides.forEach((s,i)=>{s.classList.toggle('active',i===active);s.setAttribute('aria-hidden',i===active?'false':'true')});dots.forEach((d,i)=>d.classList.toggle('active',i===active))};const play=()=>timer=setInterval(()=>show(active+1),6000);const select=n=>{clearInterval(timer);show(n);play()};dots.forEach(d=>d.addEventListener('click',()=>select(Number(d.dataset.ceDot))));prev?.addEventListener('click',()=>select(active-1));next?.addEventListener('click',()=>select(active+1));play()})})();
  (()=>{document.querySelectorAll('[data-ce-apps-carousel]').forEach(carousel=>{const track=carousel.querySelector('[data-ce-apps-track]'),slides=[...track.children],dots=[...carousel.querySelectorAll('[data-ce-apps-dot]')],prev=carousel.querySelector('[data-ce-apps-prev]'),next=carousel.querySelector('[data-ce-apps-next]');if(slides.length<2)return;let active=0,frame;const update=n=>{active=(n+slides.length)%slides.length;dots.forEach((dot,index)=>dot.classList.toggle('active',index===active))};const select=n=>{update(n);track.scrollTo({left:active*track.clientWidth,behavior:'smooth'})};prev?.addEventListener('click',()=>select(active-1));next?.addEventListener('click',()=>select(active+1));dots.forEach(dot=>dot.addEventListener('click',()=>select(Number(dot.dataset.ceAppsDot))));track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>update(Math.round(track.scrollLeft/Math.max(track.clientWidth,1))))},{passive:true});window.addEventListener('resize',()=>track.scrollTo({left:active*track.clientWidth,behavior:'auto'}))})})();
  document.querySelectorAll('[data-coupon-code]').forEach(button=>button.addEventListener('click',async()=>{const code=button.dataset.couponCode;if(!code)return;try{await navigator.clipboard.writeText(code);const labels=[...button.querySelectorAll('span')],previous=labels.map(label=>label.textContent);labels.forEach(label=>label.textContent='Copiado');window.setTimeout(()=>labels.forEach((label,index)=>label.textContent=previous[index]),1600)}catch{}}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bambulaco-flash-sale"] && !Shopify.designMode) return;
  try {
    
  const padFlashTime = (value) => String(Math.max(0, value)).padStart(2, '0');

  const updateFlashSale = (section) => {
    const countdown = section.querySelector('[data-flash-countdown]');
    const timer = section.querySelector('[data-flash-timer]');
    const ended = section.querySelector('[data-flash-ended]');
    if (!countdown || !timer) return;

    const endTime = Date.parse(section.dataset.endTime || '');
    if (Number.isNaN(endTime)) {
      countdown.hidden = true;
      return;
    }

    const render = () => {
      const remaining = endTime - Date.now();
      if (remaining <= 0) {
        timer.hidden = true;
        if (ended) ended.hidden = false;
        return false;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      section.querySelector('[data-days]').textContent = padFlashTime(Math.floor(totalSeconds / 86400));
      section.querySelector('[data-hours]').textContent = padFlashTime(Math.floor(totalSeconds % 86400 / 3600));
      section.querySelector('[data-minutes]').textContent = padFlashTime(Math.floor(totalSeconds % 3600 / 60));
      section.querySelector('[data-seconds]').textContent = padFlashTime(totalSeconds % 60);
      return true;
    };

    if (!render()) return;
    const interval = window.setInterval(() => {
      if (!document.body.contains(section) || !render()) window.clearInterval(interval);
    }, 1000);
  };

  const placeFlashSaleSuite = (suite) => {
    const placement = suite.dataset.flashPlacement;
    let target;

    if (placement === 'home') target = document.querySelector('.ce-home .ce-hero');
    if (placement === 'offers') target = document.querySelector('.offers-page .offers-hero');
    if (target && target.nextElementSibling !== suite) target.after(suite);
  };

  document.querySelectorAll('[data-flash-suite]').forEach(placeFlashSaleSuite);
  document.querySelectorAll('[data-flash-sale]').forEach((section) => {
    updateFlashSale(section);
  });
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-flash-suite]').forEach((suite) => {
      const sectionId = suite.dataset.flashSectionId;
      document.querySelectorAll(`[data-flash-suite][data-flash-section-id="${sectionId}"]`).forEach((existingSuite) => {
        if (existingSuite !== suite && !event.target.contains(existingSuite)) existingSuite.remove();
      });
      placeFlashSaleSuite(suite);
    });
    event.target.querySelectorAll('[data-flash-sale]').forEach((section) => {
      updateFlashSale(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
